const actionTypes = {
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  CACHE_USER_INFO: Symbol('CACHE_USER_INFO'),
  INIT_SUBMENU: Symbol('INIT_SUBMENU'),
  TOGGLE_SIDER_COLLAPSED: Symbol('TOGGLE_SIDER_COLLAPSED'),
  UPDATE_USER_INFO: Symbol('UPDATE_USER_INFO'),
  UPDATE_SHORTCUT_CONFIG: Symbol('UPDATE_SHORTCUT_CONFIG'),
};

export default actionTypes;
